<div>
  <div>
    <div class="d-flex" style="gap: var(--form-gap)">
      <div class="unity-form-group select" style="margin-bottom: 0">
        <ep-dropdown
          [disabled]="controlDisabled"
          [codeValues]="subLocationCodeTable$ | async"
          [(ngModel)]="value"
          (blur)="onBlur()"
          (focus)="onFocus()"
          style="width: 100%"
        ></ep-dropdown>
      </div>
      <aurora-icon-button
        *ngIf="!userDefinedMode"
        class="d-flex align-items-center"
        type="button"
        [icon]="value && value > '' ? 'pencil' : 'plus'"
        (click)="modalEdit()"
        [ngbTooltip]="value && value > '' ? 'Edit Sub Location' : 'Add Sub Location'"
        [hidden]="controlDisabled"
        [disabled]="controlDisabled"
        tabindex="-1"
      ></aurora-icon-button>
    </div>
  </div>
</div>
